const headerCls = "_275he3opj1";
const searchCls = "_275s1ni0sru";

export { headerCls, searchCls };
import "./topbar.student.style.linaria.module.css";
//# sourceMappingURL=topbar.student.style.js.map
